module.exports = __webpack_public_path__ + "img/logo-grey.d2fa405d.svg";